(ns common.transit
  (:require [cljs-bean.transit :as bean]
            [cognitect.transit :as t]
            [time-literals.read-write]
            [java.time :as jt]))

;;
;; Inspired from:
;; https://gist.github.com/jjttjj/6bc0b62ef1dbf29c1c69ea22f8eb7f55
;;
;; See also:
;; https://github.com/henryw374/time-literals/issues/2
;;

(def time-classes
  {'period jt/Period
   'date jt/LocalDate
   'date-time jt/LocalDateTime
   'zoned-date-time jt/ZonedDateTime
   'instant jt/Instant
   'time jt/LocalTime
   'duration jt/Duration
   'year jt/Year
   'year-month jt/YearMonth
   'zone jt/ZoneId
   'day-of-week jt/DayOfWeek
   'month jt/Month})

(def write-handlers
  (->> (for [[tick-class host-class] time-classes]
         [host-class (t/write-handler (constantly (name tick-class)) str)])

       (concat [[js/Error
                 (t/write-handler (constantly "Error")
                                  (fn [err]
                                    {:error/message (ex-message err)}))]

                [cljs.core/ExceptionInfo
                 (t/write-handler (constantly "ExceptionInfo")
                                  (fn [ex]
                                    {:exception/cause (ex-cause ex)
                                     :exception/data (ex-data ex)
                                     :exception/message (ex-message ex)}))]])
       (into {})))

(def read-handlers
  (->> (for [[sym fun] time-literals.read-write/tags]
         [(name sym) (t/read-handler fun)])

       (concat [["Error"
                 (t/read-handler (fn [{:error/keys [message]}]
                                   (js/Error. message)))]

                ["ExceptionInfo"
                 (t/read-handler (fn [{:exception/keys [cause data message]}]
                                   (ex-info message data cause)))]])
       (into {})))

(def default-reader
  (t/reader :json {:handlers read-handlers}))

(def default-writer
  (t/writer :json {:handlers (merge write-handlers (bean/writer-handlers))}))

(defn read
  ([str] (read default-reader str))
  ([reader str]
   (try
     (t/read reader str)
     (catch :default err
       (throw (ex-info "Transit read error"
                       {:data str
                        :error :transit-read-error}
                       err))))))

(defn write
  ([obj] (write default-writer obj))
  ([writer obj]
   (try
     (t/write writer obj)
     (catch :default err
       (throw (ex-info "Transit write error"
                       {:data obj
                        :error :transit-write-error}
                       err))))))
